const apiKey = 'GZmLzj9bRcVXu5DseDbYVyZz21liKLH1';
export default apiKey;
